import React from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";

const LanguageAndCurrency = () => {
  const [language, setLanguage] = React.useState("en");
  const [currency, setCurrency] = React.useState("INR");

  const handleLanguageChange = (event: SelectChangeEvent) => {
    setLanguage(event.target.value);
  };

  const handleCurrencyChange = (event: SelectChangeEvent) => {
    setCurrency(event.target.value);
  };

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      {/* Language Dropdown */}
      <FormControl size="small">
        <Select
          value={language}
          onChange={handleLanguageChange}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "6px",
            fontSize: 14,
            minWidth: 100,
          }}
        >
          <MenuItem value="en">English</MenuItem>
        </Select>
      </FormControl>

      {/* Currency Dropdown */}
      <FormControl size="small">
        <Select
          value={currency}
          onChange={handleCurrencyChange}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "6px",
            fontSize: 14,
            minWidth: 90,
          }}
        >
          <MenuItem value="INR">INR</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageAndCurrency;
